import { useQuery } from '@tanstack/react-query';
import { getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetOptions } from '@/client/@tanstack/react-query.gen';

/**
 * House-level document statuses for list/table views.
 * Polls periodically to refresh badges and progress.
 * Stops polling when shouldPoll is false (e.g., when setup_completed is true).
 */
export function useHouseDocumentsStatus(houseId: number | null | undefined, shouldPoll: boolean = true) {
	return useQuery({
		enabled: !!houseId,
		staleTime: 0,
		refetchInterval: shouldPoll ? 5000 : false,
		...getHouseDocumentsStatusV2HousesHouseIdDocumentsV2StatusGetOptions({ path: { house_id: houseId as number } }),
	});
}
